module.exports = __webpack_public_path__ + "img/alarm-snooze.406543c5.svg";